<template>
  <Skeleton
    class="m-today-matches"
    :loading="loading"
    empty-size="small"
    @retry="fetchData"
  >
    <!-- matches list -->
    <template v-if="hasData">
      <MatchList
        :list="todayMatches"
        :current-market-id="currentMarketId"
      />

      <ViewAll
        v-if="todayMatchesCount > 50"
        :url="viewAllUrl"
        :count="todayMatchesCount"
      />
    </template>
    <template v-else>
      <CheckAllMatches
        message="There are no matches that can be bet today."
        :link="allMatchesUrl"
      />
    </template>
  </Skeleton>
</template>

<script>
import { storeToRefs } from 'pinia'
import MatchList from 'wap/match/MatchList.vue'
import ViewAll from '../components/ViewAll'
import CheckAllMatches from '../components/CheckAllMatches'
import useHomeStore from 'wap/stores/home'

export default {
  name: 'Today',
  components: {
    MatchList,
    ViewAll,
    CheckAllMatches
  },
  props: {
    sportId: {
      type: String,
      default: ''
    },
    sportName: {
      type: String,
      default: ''
    },
    currentMarketId: {
      type: [String, Number],
      default: ''
    },
    // 是否被父级代理请求
    proxyed: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const store = useHomeStore()
    const { todayMatches, todayMatchesCount } = storeToRefs(store)
    return {
      todayMatches,
      todayMatchesCount,
    }
  },
  data () {
    return {
      loading: false // true, false -1: 加载失败
    }
  },
  computed: {
    hasData () {
      return this.todayMatches.length > 0
    },
    // 当前条件下的比赛列表
    viewAllUrl () {
      return `/sports/list/${encodeURIComponent(this.sportName)}/matches_on_today`
    },
    // 该运动项目的全部比赛列表
    allMatchesUrl () {
      return {
        name: 'matchList',
        params: {
          sportName: encodeURIComponent(this.sportName)
        }
      }
    }
  },
  watch: {
    sportId () {
      this.fetchData()
    }
  },
  created () {
    // today 列表有 live 比赛，实时性要求较高，所以需要 loading
    !this.proxyed && this.fetchData()
  },
  activated () {
    if (this.hasData) {
      useHomeStore().getTodayMatches(this.sportId).catch(() => ({}))
    }
  },
  destroyed () {
    useHomeStore().resetTodayMatches()
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        await useHomeStore().getTodayMatches(this.sportId)
        this.loading = false
      } catch (error) {
        if (error === 'canceled') {
          return
        }
        this.loading = -1
      }
    }
  }
}
</script>
